
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/staff/notification",
      function () {
        return require("private-next-pages/staff/notification/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/staff/notification"])
      });
    }
  